import CryptoJS from "crypto-js";

export const encryptSHA256 = (pin: string) => {
  return CryptoJS.SHA256(pin).toString();
};

export const decryptAES = (encrypted: string, pin: string): any => {
  const decData = CryptoJS.enc.Base64.parse(encrypted).toString(
    CryptoJS.enc.Utf8
  );

  const bytes = CryptoJS.AES.decrypt(decData, pin.toString()).toString(
    CryptoJS.enc.Utf8
  );

  return JSON.parse(bytes);
};

export const encryptAES = (word: any, pin: string): any => {
  const encJson = CryptoJS.AES.encrypt(
    JSON.stringify(word),
    pin.toString()
  ).toString();
  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
};
